import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Message } from 'semantic-ui-react'

import { signupUser } from '../../actions'
import ErrorMessage from './Error'
import CompanyField from './CompanyField'
import CreateAccountButton from './CreateAccountButton'
import NameField from './NameField'
import EmailField from './EmailField'
import { toast } from 'libs/toast'
import auth from 'auth'
import { completeOAuthInOpenerOrNavigate } from 'libs/oauthIframeBridge'
import { trackSignupCompleted } from 'libs/track-signup-completed'

const AccountCompletionForm = ({
  history,
  email,
  password,
  connectionId,
  showWarning,
  loginMethod,
}) => {
  const [name, setName] = useState('')
  const [company, setCompany] = useState('')
  const dispatch = useDispatch()

  const { loading, error } = useSelector(
    ({
      pages: {
        signup: { loading, error },
      },
    }) => ({
      loading,
      error,
    })
  )

  const onNameChange = (event) => {
    setName(event.target.value)
  }

  const onCompanyChange = (event) => {
    setCompany(event.target.value)
  }

  const submitSignup = (event) => {
    event.preventDefault()
    const [firstname, lastname] = name.split(/\s+/)
    if (firstname.length > 30) {
      return toast.error('Whoops! The first name should be less than 30 characters.')
    }
    const userInfo = {
      firstname,
      lastname,
      company: company,
      email: email,
      password: password,
      connection_id: connectionId,
    }

    if (!loading) {
      dispatch(signupUser(userInfo)).then((isAuthenticated) => {
        if (isAuthenticated) {
          trackSignupCompleted(loginMethod)
          completeOAuthInOpenerOrNavigate(history, {
            pathname: '/',
            search: history.location.search,
            replace: true,
            token: auth.getToken(),
          })
        }
      })
    }
  }

  const errorType = () =>
    _.findKey(error, (e) => {
      return e === true
    })
  const hasError = () => error.signup || error.other || error.blacklist

  return (
    <div>
      {hasError() ? <ErrorMessage type={errorType()} /> : ''}
      {showWarning && (
        <Message warning>
          <Message.Header>Heads up!</Message.Header>
          <p>
            A Simplesat account already exists for the domain{' '}
            <b>{email.split('@').pop()}. </b>
            You can contact the account owner to be invited, or continue creating a new account.
          </p>
        </Message>
      )}
      <form onSubmit={submitSignup} className="ui form mb10" style={{ textAlign: 'left' }}>
        <EmailField email={email} />
        <NameField name={name} onChange={onNameChange} />
        <CompanyField company={company} onChange={onCompanyChange} />
        <CreateAccountButton onClick={submitSignup} />
      </form>
    </div>
  )
}

AccountCompletionForm.propTypes = {
  history: PropTypes.object,
  email: PropTypes.string,
  password: PropTypes.string,
  connectionId: PropTypes.string,
  showWarning: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.object,
  loginMethod: PropTypes.string,
}

export default AccountCompletionForm



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/index.js